import { Box, Heading } from '@hover/blueprint';
import React from 'react';
import TryItOut from '../../components/common/try-it-out';
import PartnerLayout from '../../components/layout';
import Footer from '../../components/layout/footer';
import VideoGrid from '../../components/resources-page/videoGrid';

const index = () => (
  <PartnerLayout
    navbarBackgroundColor="neutral.100"
    title="Resources - Beacon 3D+"
  >
    <Box
      minH={{ base: 700, desktop: 800 }}
      px={400}
      textAlign="center"
      bgColor="neutral.100"
      w="100%"
      alignItems="center"
      justifyContent="center"
      mb={{ base: 25, desktop: 84 }}
    >
      <Heading size={{ base: 600, desktop: 700 }} sx={{ mb: 0 }}>
        Watch these videos to get a quick overview of Beacon 3D+
      </Heading>
    </Box>

    <Box
      p={{ base: 600, tablet: 400 }}
      maxW={{ desktop: '7xl', base: '5xl' }}
      w="100%"
    >
      <VideoGrid />
    </Box>

    <TryItOut
      title="Try Beacon 3D+ today"
      body="Start your free trial of Beacon 3D+ to see how the platform measures up."
      cta={{ title: 'Start Free Trial', url: './signup/' }}
      my={24}
    />

    <Footer />
  </PartnerLayout>
);

export default index;
